import React, { createContext, useContext, useState, useCallback } from 'react';
import { axiosTimeout } from '../helpers/axiosTimeout';
import api from '../services/api';

const GlobalContext = createContext();

const GlobalProvider = ({ children }) => {
  const searchUser = useCallback(async ({ searchData }) => {
    try {
      const token = localStorage.getItem('@Braspress:token');

      const response = await api.get(
        `${process.env.REACT_APP_URL_MS_PICKUP}/api/v1/clients`,
        {
          headers: {
            Authorization: `Bearer ${token}`
          },
          params: searchData,
          timeout: axiosTimeout
        }
      );

      const list = response.data.data;

      if (list && list.length > 0) {
        const newList = list.map((user) => {
          if (user?.zipPostalCode.length < 8) {
            user.zipPostalCode = `0${user?.zipPostalCode}`;
          }

          if (!user?.streetAddressNumber) {
            user.streetAddressNumber = '';
          }

          user.contact = String(user?.contact || '').replace(
            /[^a-zA-Z0-9 ]/g,
            ''
          );

          return user;
        });

        return newList;
      }

      return [];
    } catch (error) {
      return error;
    }
  }, []);

  const contextValue = {
    searchUser
  };

  return (
    <GlobalContext.Provider value={contextValue}>
      {children}
    </GlobalContext.Provider>
  );
};

function useApp() {
  const context = useContext(GlobalContext);

  if (!context) {
    throw new Error('useApp must be used within an GlobalProvider');
  }

  return context;
}

export { GlobalProvider, useApp };
